import { useEffect } from "react";
import { withBusinessLogos } from "@/data/businessLogo";

// Static production HTML owns these records; preview adds them only when absent.
export default function useOwnedPhotoSchemas(schemas: Record<string, unknown>[]) {
  useEffect(() => {
    const heroId = schemas[0]?.["@id"];
    if (typeof heroId !== "string") return;
    const alreadyPresent = Array.from(document.querySelectorAll('script[type="application/ld+json"]'))
      .some(script => script.textContent?.includes(heroId));
    if (alreadyPresent) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.ownedPhotos = "true";
    script.textContent = JSON.stringify(withBusinessLogos(schemas));
    document.head.appendChild(script);
    return () => script.remove();
  }, [schemas]);
}